import {get} from 'lodash';

import {D3TreeData, TreePointNode} from './d3.interface';

export class DepthNodesCount<T extends D3TreeData<T>> {
  private readonly root: TreePointNode<T>;
  private depthNodeCount = new Map() as Map<number, number>;

  constructor(root: TreePointNode<T>) {
    this.root = root;
  }

  getTotalNodeCount() {
    this.countNodes(0, this.root);

    return this.getAllDepthsNodesCount().reduce((acc, value) => (acc += value), 0);
  }

  private countNodes(currentDepth, currentNode) {
    const {children} = currentNode;
    const nodeHasChildren = get(children, 'length');

    if (nodeHasChildren) {
      const nextDepth = currentDepth + 1;

      this.accumulateNodeCount(children.length, {depth: nextDepth});

      children.forEach(node => this.countNodes(nextDepth, node));
    }
  }

  private accumulateNodeCount(count, {depth}) {
    const currentNodeCount = this.getNodeCount(depth);

    this.setNodeCount(currentNodeCount + count, {depth});
  }

  private getNodeCount(depth) {
    return this.depthNodeCount.get(depth) || 0;
  }

  private setNodeCount(count: number, {depth}: {depth: number}) {
    this.depthNodeCount.set(depth, count);
  }

  private getAllDepthsNodesCount() {
    return [...this.depthNodeCount.values()];
  }
}
